export const WEBSITE_URL = 'https://www.skipr.co'
export const TERMS_AND_CONDITIONS_URL = WEBSITE_URL + '/terms'
export const PRIVACY_POLICY_URL = WEBSITE_URL + '/privacy'
